import React from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

// interface LeadAllocationTableProps {
//   value: any[];
//   loading: boolean;
//   onRowClick: (rowData: any) => void;
// }

interface LeadAllocationTableProps {
  value: any[];
  loading: boolean;
  onColumnClick: (
    rowData: any,
    emailSent?: boolean,
    callMade?: boolean
  ) => void;
}
export const LeadAllocationTable: React.FC<LeadAllocationTableProps> = ({
  value,
  loading,
  onColumnClick,
}) => {
  return (
    <DataTable
      value={value}
      loading={loading}
      stripedRows
      showGridlines
      responsiveLayout="scroll"
      emptyMessage="No lead allocation summary found."
      size="small"
      // onRowClick={(e) => onRowClick(e.data)}
      // rowClassName={() => "cursor-pointer hover:bg-blue-50"}
      style={{ border: "1px solid rgba(105,105,105,0.17)", borderTopWidth: "0" }}
    >
      <Column
        header="Allocation At"
        body={(rowData: any) => {
          if (!rowData.allocationDateTime) return "-";

          const date = new Date(rowData.allocationDateTime);

          return (
            <span
              style={{
                color: "#2196F3",
                textDecoration: "underline",
                fontWeight: "600",
              }}
              onClick={() => onColumnClick(rowData)}

            >
              {date.toLocaleDateString("en-IN", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
              })}
            </span>
          );
        }}
        style={{ width: "20%" }}
      />
      <Column
        header="Team Member"
        body={(rowData: any) => (
          <span style={{ color: "#2196F3", textDecoration: "underline", fontWeight: "500" }}
            onClick={() => onColumnClick(rowData)}
          >
            {rowData.teamMemberName || "-"}
          </span>
        )}
      />
      <Column field="allocatedBy" header="Allocated By" />
      <Column
        field="totalAllocated"
        header="Total Allocated"
        className="text-center"
        style={{ width: "20%" }}
        body={(rowData: any) => (
          <span
            style={{
              color: "#2196F3",
              textDecoration: "underline",
              fontWeight: "500",
              cursor: "pointer",
            }}
            onClick={() => onColumnClick(rowData)}
          >
            {rowData.totalAllocated || "-"}
          </span>
        )}
      />
      <Column
        field="emailsSent"
        header="Emails Sent"
        body={(rowData: any) => (
          <span
            style={{
              color: "#2196F3",
              textDecoration: "underline",
              cursor: "pointer",
            }}
            onClick={() => onColumnClick(rowData, true, false)}
          >
            {rowData.emailsSent}
          </span>
        )}
      />
      <Column
        field="callsCompleted"
        header="Calls Completed"
        body={(rowData: any) => (
          <span
            style={{
              color: "#2196F3",
              textDecoration: "underline",
              cursor: "pointer",
            }}
            onClick={() => onColumnClick(rowData, false, true)}
          >
            {rowData.callsCompleted}
          </span>
        )}
      />
    </DataTable>
  );
};
